module.exports = __webpack_public_path__ + "img/VideoSettingsOutlined.b5cdad39.svg";